export const SOURCES = {
  POLICY_MANAGEMENT: 'policy-management',
}

export const BASE_USERS = [{ label: 'Guests / External Users', value: 'GuestsOrExternalUsers' }]

export const BASE_INCLUDE_USERS = [
  { label: 'All users', value: 'All' },
  { label: 'No users', value: 'None' },
  ...BASE_USERS,
]

export const BASE_LOCATIONS = [{ label: 'All trusted locations', value: 'AllTrusted' }]

export const BASE_INCLUDE_LOCATIONS = [{ label: 'All', value: 'All' }, ...BASE_LOCATIONS]

export const BASE_APPLICATIONS = [
  { label: 'Office 365', value: 'Office365' },
  { label: 'Microsoft Admin Portals', value: 'MicrosoftAdminPortals' },
]

export const BASE_INCLUDE_APPLICATIONS = [
  { label: 'None', value: 'None' },
  { label: 'All', value: 'All' },
  ...BASE_APPLICATIONS,
]

export const DEFAULT_EMPTY_POLICY = {
  state: 'enabledForReportingButNotEnforced',
  conditions: {
    users: {
      includeUsers: ['None'],
    },
    applications: {
      includeApplications: ['None'],
    },
    clientAppTypes: ['all'],
  },
  grantControls: {
    operator: 'AND',
    builtInControls: ['mfa'],
  },
}

export const POLICY_STATE_REPORT = 'enabledForReportingButNotEnforced'
